import pkg from "../../package.json";

export default function version() {
  return `${pkg.version}${
    process.env.NODE_ENV === "development" ? "-dev" : ""
  }`;
}
